<script setup lang="ts">
import { ROUTE_NAMES } from "@/router/routes";
import { useTerminalsStore } from "@/stores/terminals";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const terminalsStore = useTerminalsStore();

const { activeTerminal } = storeToRefs(terminalsStore);

const pageName = computed(() => route.name);
const lastTankToTankPlanId = computed(
  () => route.params && route.params.tankToTankPlanId,
);
const isTankToTankPlan = computed(
  () => route.meta && route.meta.tankToTankPlan,
);
const routes = computed(
  () =>
    router.options.routes.filter((t) => t.name === ROUTE_NAMES.TANK_TO_TANK)[0]
      .children,
);

function handleRoute(path: string) {
  if (path.includes(":terminalId"))
    path = path.replace(
      ":terminalId?",
      (activeTerminal.value?.id ?? 0).toString(),
    );
  if (path.includes(":tankToTankPlanId"))
    path = path.replace(
      ":tankToTankPlanId",
      lastTankToTankPlanId.value.toString(),
    );

  if (route.path !== path) return path;
}
</script>
<template>
  <v-container v-if="lastTankToTankPlanId && isTankToTankPlan">
    <v-list expand nav :selected="route.name">
      <template v-for="(item, i) in routes" :key="i">
        <v-list-group
          v-show="item.meta?.display"
          no-action
          :group="handleRoute(item.path)"
          color="orange"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :prepend-icon="item.meta?.icon as string"
              class="pl-0"
              color="orange"
            >
              <v-list-item-title class="parent-title">
                {{ item.meta?.title as string }}
              </v-list-item-title>
            </v-list-item>
          </template>

          <template v-for="(subItem, j) in item.children" :key="j">
            <v-list-item
              v-show="subItem.meta?.display"
              :to="handleRoute(item.path + '/' + subItem.path)"
              color="orange"
              :class="[pageName === subItem.name ? 'v-list-item--active' : '']"
              :title="subItem.meta?.title as string"
            />
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-container>
</template>

<style lang="scss" scoped>
.v-list-item--disabled {
  color: rgb(94, 94, 94) !important;
}
:deep(.v-list-item) {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  color: white;
}

.parent-title {
  font-weight: bolder !important;
  font-size: 16px !important;
}

:deep(.v-list-item--disabled) {
  color: rgb(94, 94, 94) !important;
}

:deep(.v-list-item--active) {
  color: orange !important;
}
</style>
